import { useState, useEffect } from 'react';

import { CHATBOT_LOADING_MESSAGES } from 'utils/constants/chatbot';

const ChatLoader = () => {
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    const msgsLength = CHATBOT_LOADING_MESSAGES.length;

    const interval = setInterval(() => {
      setMsgIdx(prev => (prev < msgsLength - 1 ? prev + 1 : prev));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='bg-white w-fit max-w-[340px] dark:bg-gray-700 rounded-e-2xl rounded-ss-2xl rounded-es-lg px-3 py-2 border border-gray-400 dark:border-gray-600'>
      <div className='flex items-center gap-2'>
        <img
          src={CHATBOT_LOADING_MESSAGES[msgIdx].icon}
          alt='Loader'
          className='w-5 h-5'
        />
        <span className='text-sm dark:text-white'>
          {CHATBOT_LOADING_MESSAGES[msgIdx].text}
        </span>
      </div>
    </div>
  );
};

export default ChatLoader;
